/* MALLIENA – 3 hoodies for $249 pack (adds on top of theme.js) */
(function(){
  var form=document.querySelector('[data-product-form]'); if(!form) return;
  var packEl=form.querySelector('[data-pack]'), s2=form.querySelector('[data-size2]');
  var pj=document.querySelector('[data-product-json]'); if(!packEl||!s2||!pj) return;
  var product=JSON.parse(pj.textContent), M=window.MALLIENA||{};
  var idIn=form.querySelector('[data-variant-id]'), addBtn=form.querySelector('[data-add]'), addLbl=form.querySelector('[data-add-label]');
  var PRICE3=24900;

  // headline offer text
  var b2=document.querySelector('.b2');
  if(b2) b2.innerHTML='<b>Buy 2, pay $179. Buy 3, pay $249.</b> Same design or mix any. The discount is applied automatically.';

  // 3-hoodie option
  var unit=(product.variants[0]&&product.variants[0].price)||product.price;
  var save3=Math.max(0,unit*3-PRICE3);
  var opt3=document.createElement('label'); opt3.className='pack__o';
  opt3.innerHTML='<input type="radio" name="pack" value="3"><span class="pack__t"><b>3 Hoodies</b>'+(save3?' <small>SAVE $'+(save3/100).toFixed(2)+'</small>':'')+'</span><span class="pack__p">$249</span><i class="pack__tag">BEST VALUE</i>';
  packEl.appendChild(opt3);

  // size picker for the 3rd hoodie (copy of the 2nd one)
  var s3=s2.cloneNode(true);
  s3.removeAttribute('data-size2'); s3.setAttribute('data-size3',''); s3.hidden=true;
  s3.querySelector('legend').textContent='Size for your 3rd hoodie';
  Array.prototype.forEach.call(s3.querySelectorAll('[data-value2]'),function(b){b.setAttribute('data-value3',b.getAttribute('data-value2'));b.removeAttribute('data-value2');});
  var mix2=s2.querySelector('.pack__mix'), mix3=s3.querySelector('.pack__mix');
  var mixTxt='Want different designs? Add any other hoodies to your bag and the pack price applies too.';
  if(mix2) mix2.textContent=mixTxt; if(mix3) mix3.textContent=mixTxt;
  s2.parentNode.insertBefore(s3,s2.nextSibling);
  s3.addEventListener('click',function(e){var b=e.target.closest('[data-value3]');if(!b)return;
    Array.prototype.forEach.call(s3.querySelectorAll('[data-value3]'),function(x){x.setAttribute('aria-pressed',x===b?'true':'false')});});

  function pack(){var r=packEl.querySelector('input:checked');return r?parseInt(r.value,10):1;}
  function sync(){
    var p=pack();
    s2.hidden=p<2; s3.hidden=p!==3;
    if(mix2) mix2.hidden=p===3;
    if(p===3&&addLbl&&addBtn&&!addBtn.disabled) addLbl.textContent='ADD 3 TO BAG – $249';
  }
  packEl.addEventListener('change',function(){setTimeout(sync,0);});
  form.addEventListener('click',function(){setTimeout(sync,0);});

  function pressed(fs,attr){var b=fs.querySelector('['+attr+'][aria-pressed="true"]');return b?b.getAttribute(attr):null;}
  function variantFor(size){
    var base=product.variants.filter(function(v){return String(v.id)===String(idIn.value)})[0];
    if(!base||!size) return base;
    var o=base.options.slice(); o[0]=size;
    return product.variants.filter(function(v){return v.options.join('|')===o.join('|')})[0]||base;
  }
  function openCart(){var t=document.createElement('button');t.type='button';t.setAttribute('data-open','cart');t.hidden=true;document.body.appendChild(t);t.click();t.remove();}

  document.addEventListener('submit',function(e){
    if(e.target!==form||pack()!==3) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var list=[variantFor(null),variantFor(pressed(s2,'data-value2')),variantFor(pressed(s3,'data-value3'))];
    var qty={}; list.forEach(function(v){if(v) qty[v.id]=(qty[v.id]||0)+1;});
    var items=Object.keys(qty).map(function(id){return {id:parseInt(id,10),quantity:qty[id]};});
    addBtn.disabled=true;
    items.reduce(function(p,it){return p.then(function(){return fetch((M.rootUrl||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:it.id,quantity:it.quantity})})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});});});},Promise.resolve())
      .then(function(){addBtn.disabled=false;openCart();})
      .catch(function(err){addBtn.disabled=false;if(addLbl)addLbl.textContent=(err&&err.description)||'Could not add to bag';});
  },true);
})();
